import {
  sectorsApiUpsellProvider,
  eventTypesApiUpsellProvider,
  eventsApiUsellProvider,
  eventApiUpsellProvider,
  surveysApiUpsellProvider,
  sectorPdcsProvider,
  usersApiUpsellProvider,
  luccaApiUpsellProvider
} from "../../lib/api/providers";

import { sources } from "../../configs/constants";
import { defaultStartDate, defautlEndDate } from "../reducers/planningReducer";

export const getAvailableDateRangeApi = token => {
  return surveysApiUpsellProvider
    .post(
      "/distincts/SurveyPeriodicity",
      {
        match: {
          "status.id": 2
        }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

export const getUsersApiGivenAClientFromSectors = (token, clientId, currentUser) => {
  if (!clientId) clientId = 1;

  return sectorsApiUpsellProvider
    .post(
      "/",
      {
        match: { client_id: clientId },
        project: { users: 1 }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      let listUsers = response.data
        .map(sector => sector.users)
        .flat()
        .filter(user => (user.role_id > currentUser.role_id || user.email === currentUser.email) && user.role_id !== 5)
        .sort((a, b) => (a.email > b.email ? 1 : -1));
      if (currentUser.role_id === 1)
        listUsers = response.data
          .map(sector => sector.users)
          .flat()
          .filter(user => user.role_id !== 5)
          .sort((a, b) => (a.email > b.email ? 1 : -1));
      return listUsers;
    });
};
export const getUsersOfManager = (token, clientId, currentUser) => {
  if (!clientId) clientId = 1;

  return usersApiUpsellProvider
    .post(
      "/",
      {
        match: { "clients.id": clientId, effectif: true, role_id: { $gte: currentUser.role_id } }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      let users = response.data
        .filter(user => user.role_id !== 5)
        .filter(
          user => currentUser.role_id === 1 || currentUser.email === user.email || user.role_id > currentUser.role_id
        )
        .filter(({ email }) => email !== "jerome.balay@upsell.fr" && email !== "eric.grasland@upsell.fr")
        .sort((a, b) => (a.email > b.email ? 1 : -1));

      return users;
    });
};

export const getDistinctSectorsApi = (date, currentClientId) => {
  return surveysApiUpsellProvider
    .post("/distincts/retailer.idRetailer", {
      match: {
        "SurveyPeriodicity.startDate": { $lte: { $date: date } },
        "SurveyPeriodicity.endDate": { $gte: { $date: date } },
        client_id: currentClientId
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

export const getAllSectorsApi = (email, clientId) => {
  const match = email ? { "users.email": email, client_id: clientId } : { client_id: clientId };

  return sectorsApiUpsellProvider
    .post("/", {
      match: match
      // project: { sector_label: 1, sector_id: 1 , salepoints: 1},
    })
    .then((response = {}) => {
      return response.data;
    });
};

export const getRetailersOfSurveysApi = (date, sectorLabel, currentClientId) => {
  return surveysApiUpsellProvider
    .post("/distincts/retailer.idRetailer", {
      match: {
        "SurveyPeriodicity.startDate": { $lte: { $date: date } },
        "SurveyPeriodicity.endDate": { $gte: { $date: date } },
        // "sectors.label": sectorLabel,
        client_id: currentClientId
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

export const getTypesVisitApi = clientId => {
  return eventTypesApiUpsellProvider
    .post("/", {
      match: {
        client_id: clientId
      }
    })
    .then((response = {}) => {
      return response.data.filter(visit => sources.equals(visit.type_en, "visit"));
    });
};

export const getEventTypeApi = clientId => {
  return eventTypesApiUpsellProvider
    .post("/", {
      match: {
        client_id: clientId
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

export const getEventsApi = (state = {}, token, clientId, userTerrainEmail) => {
  const dateRange = state.currentDateRange || { start: defaultStartDate, end: defautlEndDate };
  const dateRangeFilter = { start_date: { $gte: { $date: dateRange.start }, $lte: { $date: dateRange.end } } };
  const currentFilters = userTerrainEmail ? { user_email: userTerrainEmail } : state.currentFilters || {};
  if (!currentFilters.user_email) return [];
  return eventsApiUsellProvider
    .post(
      "/",
      {
        match: {
          ...currentFilters,
          ...dateRangeFilter,
          client_id: clientId,
          $or: [
            {
              not_planned: true,
              visit_id: { $exists: true }
            },
            {
              not_planned: false
            }
          ]
        }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

export const getLuccaPlanningVacationsApi = (state = {}, token) => {
  const dateRange = state.currentDateRange || { start: defaultStartDate, end: defautlEndDate };
  const selectedEmail = state.selectedEmail;
  if (!selectedEmail) return [];

  return luccaApiUpsellProvider
    .post(
      "/planning-vacations",
      {
        user_email: selectedEmail,
        start_date: dateRange.start,
        end_date: dateRange.end
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

export const createNewEventApi = (event, token) => {
  return eventApiUpsellProvider
    .post("/", event, {
      headers: {
        Authorization: token
      }
    })
    .then(response => {
      const { user_fullName, pdc_label } = response.data;
      const requestReponse = `Evénement ${pdc_label} de ${user_fullName} a été enregistré`;

      return { status: 1, text: requestReponse };
    })
    .catch(error => {
      return { status: 0, text: error.response.data.data.message };
    });
};

export const updateEventApi = (event, token) => {
  return eventApiUpsellProvider
    .put("/", event, {
      headers: {
        Authorization: token
      }
    })
    .then(response => {
      const { user_fullName, pdc_label } = response.data;
      const requestReponse = `Evénement ${pdc_label} de ${user_fullName} a été mis à jour`;

      return { status: 1, text: requestReponse };
    })
    .catch(error => {
      return { status: 0, text: error.response.data.data.message };
    });
};

export const deleteEventApi = (event, token) => {
  return eventApiUpsellProvider
    .delete(`/${event._id}`, {
      headers: {
        Authorization: token
      }
    })
    .then(response => {
      const requestReponse = `Evénement ${event.pdc_label} de ${event.user_fullName} a bien été supprimé`;

      return { status: 1, text: requestReponse };
    })
    .catch(error => {
      return { status: 0, text: error.response.data.data.message };
    });
};

export const getUserSectorsApi = (date, currentClientId) => {
  return surveysApiUpsellProvider
    .post(`/distincts/sectors`, {
      match: {
        "SurveyPeriodicity.startDate": { $lte: { $date: date } },
        "SurveyPeriodicity.endDate": { $gte: { $date: date } },
        client_id: currentClientId
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

export const getSector_pdcsApi = ({ sector_id, client_id }, token) => {
  return sectorPdcsProvider
    .post(
      "/",
      {
        match: { sector_id, client_id, deleted: false },
        project: {
          _id: 0,
          created_at: 0,
          updated_at: 0,
          deleted_updated_at: 0,
          __v: 0
        },
        sort: { pdc_label: 1 }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};



// WEBPACK FOOTER //
// src/redux/sagas/planning.api.js